import { useMemo } from "react";
import { UAParser } from "ua-parser-js";

export function useUserAgent(userAgent?: string) {
  const { ua, device, os } = useMemo(() => UAParser(userAgent || window.navigator.userAgent), [userAgent]);

  const isGoMobile = ua.includes("GoMobile");
  const isMobile = device.type === "mobile";
  const isAndroid = os.name === "Android";
  const isIOS = os.name === "iOS";
  const isDesktop = device.type === undefined || !["wearable", "mobile"].includes(device.type);
  const isWindows = os.name === "Windows";
  const isMac = os.name === "Mac OS";
  const isLinux = os.name === "Linux";

  return {
    isGoMobile,
    isMobile,
    isAndroid,
    isIOS,
    isDesktop,
    isWindows,
    isMac,
    isLinux,
  };
}
